import { GetterTree } from 'vuex';
import { MiniTableState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<MiniTableState, RootState> = {};
